import { getRecentlyViewedProducts } from "@repo/server-actions/product";
import { useEffect, useState, useTransition } from "react";

const useRecentlyViewedProducts = (productSku, locale) => {
  const [products, setProducts] = useState([]);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    if (!productSku) return;

    let recentlyViewed =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];

    // Remove the current product & prevent duplicates
    recentlyViewed = [
      ...new Set(recentlyViewed.filter((sku) => sku !== productSku)),
    ];

    // Update localStorage
    localStorage.setItem(
      "recentlyViewed",
      JSON.stringify([productSku, ...recentlyViewed].slice(0, 10))
    );

    // Don't make an API call if there's nothing to fetch
    if (recentlyViewed.length === 0) return;

    startTransition(async () => {
      try {
        const response = await getRecentlyViewedProducts(
          recentlyViewed,
          locale
        );
        setProducts(response || []);
      } catch (error) {
        console.error("Failed to fetch recently viewed products", error);
        setProducts([]);
      }
    });
  }, [productSku, locale]);

  return { products, isPending };
};

export default useRecentlyViewedProducts;
